import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

function svg(props: IconProps): IconProps {
  return {
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
    ...props,
  };
}

export function IconMic(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" {...props}>
      <path d="M17.5 6.4165C17.5 4.48351 15.933 2.9165 14 2.9165C12.067 2.9165 10.5 4.48351 10.5 6.4165V13.4165C10.5 15.3495 12.067 16.9165 14 16.9165C15.933 16.9165 17.5 15.3495 17.5 13.4165V6.4165Z" stroke="#FFC83D" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.83203 12.8335C5.83203 14.9994 6.69245 17.0767 8.22399 18.6082C9.75554 20.1397 11.8328 21.0002 13.9987 21.0002M13.9987 21.0002C16.1646 21.0002 18.2419 20.1397 19.7734 18.6082C21.3049 17.0767 22.1654 14.9994 22.1654 12.8335M13.9987 21.0002V25.0835" stroke="#FFC83D" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconWallet(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" {...props}>
      <path d="M21 7H7C5.067 7 3.5 8.567 3.5 10.5V18.6667C3.5 20.5997 5.067 22.1667 7 22.1667H21C22.933 22.1667 24.5 20.5997 24.5 18.6667V10.5C24.5 8.567 22.933 7 21 7Z" stroke="#FFC83D" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.668 14.5835H21.5846" stroke="#FFC83D" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconCheck(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <path d="M4.16797 10.4167L7.91797 14.1667L15.8346 6.25" stroke="#4ADE80" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconInfo(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 11v5M12 8h.01" />
    </svg>
  );
}

export function IconBack(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <path d="M15 6 9 12l6 6" />
    </svg>
  );
}

export function IconClose(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <path d="M7 7l10 10M17 7 7 17" />
    </svg>
  );
}

export function IconChevron(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <path d="m9 6 6 6-6 6" />
    </svg>
  );
}

export function IconPlay(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <path d="M9 7.5v9l8-4.5-8-4.5Z" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IconPause(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <path d="M9 7v10M15 7v10" />
    </svg>
  );
}

export function IconStop(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <rect x="8" y="8" width="8" height="8" rx="1.5" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IconTrash(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <path d="M5 8h14M9 8V6h6v2M8 8l1 11h6l1-11" />
    </svg>
  );
}

export function IconRefresh(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <path d="M20 12a8 8 0 1 1-2.2-5.5" />
      <path d="M20 5v5h-5" />
    </svg>
  );
}

export function IconSearch(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <circle cx="11" cy="11" r="6" />
      <path d="m20 20-3.5-3.5" />
    </svg>
  );
}

export function IconSend(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <path d="M5 12h12M13 7l5 5-5 5" />
    </svg>
  );
}

export function IconLock(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <rect x="6" y="11" width="12" height="9" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </svg>
  );
}

export function IconEye(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" {...props}>
      <path d="M1.83203 11.0002C1.83203 11.0002 5.04036 4.5835 10.9987 4.5835C16.957 4.5835 20.1654 11.0002 20.1654 11.0002C20.1654 11.0002 16.957 17.4168 10.9987 17.4168C5.04036 17.4168 1.83203 11.0002 1.83203 11.0002Z" stroke="#FFC83D" strokeWidth="2.01667" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11 13.75C12.5188 13.75 13.75 12.5188 13.75 11C13.75 9.48122 12.5188 8.25 11 8.25C9.48122 8.25 8.25 9.48122 8.25 11C8.25 12.5188 9.48122 13.75 11 13.75Z" stroke="#FFC83D" strokeWidth="2.01667" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconEyeOff(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <path d="M4 5l16 14M9.5 9.7A3 3 0 0 0 14.3 14.5" />
      <path d="M7 8.2C4.8 9.6 3 12 3 12s4 6 9 6c1.4 0 2.7-.4 3.8-1M10 6.2A10 10 0 0 1 12 6c5 0 9 6 9 6a16 16 0 0 1-2.2 2.8" />
    </svg>
  );
}

export function IconUser(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" {...props}>
      <path d="M10.4987 13.9998C13.076 13.9998 15.1654 11.9105 15.1654 9.33317C15.1654 6.75584 13.076 4.6665 10.4987 4.6665C7.92137 4.6665 5.83203 6.75584 5.83203 9.33317C5.83203 11.9105 7.92137 13.9998 10.4987 13.9998Z" stroke="#FFC83D" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2.91797 23.3332C2.91797 19.2498 6.41797 16.9165 10.5013 16.9165M17.5013 19.8332L19.8346 22.1665L24.5013 17.4998" stroke="#FFC83D" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconShield(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <path d="M12 3 5 6v6c0 4.2 2.8 7.2 7 8.5 4.2-1.3 7-4.3 7-8.5V6l-7-3Z" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  );
}

export function IconMail(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" {...props}>
      <path d="M21 5.8335H7C5.067 5.8335 3.5 7.4005 3.5 9.3335V18.6668C3.5 20.5998 5.067 22.1668 7 22.1668H21C22.933 22.1668 24.5 20.5998 24.5 18.6668V9.3335C24.5 7.4005 22.933 5.8335 21 5.8335Z" stroke="#FFC83D" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.66797 8.75L14.0013 15.75L23.3346 8.75" stroke="#FFC83D" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconClock(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v5l3 2" />
    </svg>
  );
}

export function IconSpeaker(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <path d="M5 10v4h3l4 3V7L8 10H5Z" />
      <path d="M16 9.5a3.5 3.5 0 0 1 0 5" />
    </svg>
  );
}

export function IconLogout() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path d="M6.75 3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V13.5C3 13.8978 3.15804 14.2794 3.43934 14.5607C3.72064 14.842 4.10218 15 4.5 15H6.75M12 12L15 9L12 6M15 9H7.5" stroke="white" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconEdit(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <path d="M4 20h4l10-10-4-4L4 16v4Z" />
      <path d="m13 7 4 4" />
    </svg>
  );
}

export function IconMenu(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <path d="M4 7h16M4 12h16M4 17h16" />
    </svg>
  );
}

export function IconList(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <path d="M9 7h11M9 12h11M9 17h11" />
      <path d="M5 7h.01M5 12h.01M5 17h.01" />
    </svg>
  );
}

export function IconCard(props: IconProps) {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" {...props}>
        <path d="M16.5 5.5H5.5C3.98122 5.5 2.75 6.73122 2.75 8.25V14.6667C2.75 16.1854 3.98122 17.4167 5.5 17.4167H16.5C18.0188 17.4167 19.25 16.1854 19.25 14.6667V8.25C19.25 6.73122 18.0188 5.5 16.5 5.5Z" stroke="#4ADE80" strokeWidth="2.01667" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.668 11.4585H16.9596" stroke="#4ADE80" strokeWidth="2.01667" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
  );
}

export function IconDoc(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <path d="M7 3h7l5 5v13H7V3Z" />
      <path d="M14 3v5h5M9 13h6M9 17h6" />
    </svg>
  );
}

export function IconArrow(props: IconProps) {
  return (
    <svg {...svg(props)}>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  );
}


export function IconApply(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      {...props}
    >
      <path
        d="M19.25 4.125H9.625C8.89565 4.125 8.19618 4.41473 7.68046 4.93046C7.16473 5.44618 6.875 6.14565 6.875 6.875V26.125C6.875 26.8543 7.16473 27.5538 7.68046 28.0695C8.19618 28.5853 8.89565 28.875 9.625 28.875H23.375C24.1043 28.875 24.8038 28.5853 25.8353 27.5538C25.8353 27.5538 26.125 26.8543 26.125 26.125V11L19.25 4.125Z"
        stroke="#FFC83D"
        strokeWidth="2.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.25 4.125V11H26.125M12.375 17.875H20.625M12.375 23.375H20.625"
        stroke="#FFC83D"
        strokeWidth="2.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconJoin(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      {...props}
    >
      <path
        d="M16.5 16.5C19.5376 16.5 22 14.0376 22 11C22 7.96243 19.5376 5.5 16.5 5.5C13.4624 5.5 11 7.96243 11 11C11 14.0376 13.4624 16.5 16.5 16.5Z"
        stroke="#FFC83D"
        strokeWidth="2.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.1875 27.5C6.1875 22 11 19.25 16.5 19.25C22 19.25 26.8125 22 26.8125 27.5"
        stroke="#FFC83D"
        strokeWidth="2.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const PayIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    {...props}
  >
    <path
      d="M18 31.5C25.4558 31.5 31.5 25.4558 31.5 18C31.5 10.5442 25.4558 4.5 18 4.5C10.5442 4.5 4.5 10.5442 4.5 18C4.5 25.4558 10.5442 31.5 18 31.5Z"
      stroke="#FFC83D"
      strokeWidth={2.7}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.75 13.5C21.75 10.95 14.25 10.95 14.25 14.7C14.25 18.75 21.75 16.95 21.75 21C21.75 24.75 14.25 24.75 14.25 21.75M18 9V11.25M18 24.75V27"
      stroke="#FFC83D"
      strokeWidth={2.7}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ClearRightIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    {...props}
  >
    <path
      d="M21 4.5H10.5C9.70435 4.5 8.94129 4.81607 8.37868 5.37868C7.81607 5.94129 7.5 6.70435 7.5 7.5V28.5C7.5 29.2956 7.81607 30.0587 8.37868 30.6213C8.94129 31.1839 9.70435 31.5 10.5 31.5H25.5C26.2956 31.5 27.0587 31.1839 27.6213 30.6213C28.1839 30.0587 28.5 29.2956 28.5 28.5V12L21 4.5Z"
      stroke="#FFC83D"
      strokeWidth={2.7}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 4.5V12H28.5M13.5 19.5H22.5M13.5 25.5H22.5"
      stroke="#FFC83D"
      strokeWidth={2.7}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


export const SecureIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    {...props}
  >
    <path
      d="M24 15.75H12C9.51472 15.75 7.5 17.7647 7.5 20.25V26.25C7.5 28.7353 9.51472 30.75 12 30.75H24C26.4853 30.75 28.5 28.7353 28.5 26.25V20.25C28.5 17.7647 26.4853 15.75 24 15.75Z"
      stroke="#FFC83D"
      strokeWidth={2.7}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 15.75V12C12 10.4087 12.6321 8.88258 13.7574 7.75736C14.8826 6.63214 16.4087 6 18 6C19.5913 6 21.1174 6.63214 22.2426 7.75736C23.3679 8.88258 24 10.4087 24 12V15.75"
      stroke="#FFC83D"
      strokeWidth={2.7}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CloseIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    {...props}
  >
    <path
      d="M5.5 5.5L16.5 16.5M16.5 5.5L5.5 16.5"
      stroke="#FFC83D"
      strokeWidth={1.83333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EarningCardIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M13.5 4.5H4.5C3.25736 4.5 2.25 5.50736 2.25 6.75V12C2.25 13.2426 3.25736 14.25 4.5 14.25H13.5C14.7426 14.25 15.75 13.2426 15.75 12V6.75C15.75 5.50736 14.7426 4.5 13.5 4.5Z"
      stroke="#9A968F"
      strokeWidth={1.65}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 9.375H13.875"
      stroke="#9A968F"
      strokeWidth={1.65}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MicrophoneIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M11.25 4.125C11.25 2.88236 10.2426 1.875 9 1.875C7.75736 1.875 6.75 2.88236 6.75 4.125V8.625C6.75 9.86764 7.75736 10.875 9 10.875C10.2426 10.875 11.25 9.86764 11.25 8.625V4.125Z"
      stroke="#FFC83D"
      strokeWidth={1.65}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 8.25C3.75 9.64239 4.30312 10.9777 5.28769 11.9623C6.27226 12.9469 7.60761 13.5 9 13.5M9 13.5C10.3924 13.5 11.7277 12.9469 12.7123 11.9623C13.6969 10.9777 14.25 9.64239 14.25 8.25M9 13.5V16.125"
      stroke="#FFC83D"
      strokeWidth={1.65}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MicBlackIcon = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M12.5 4.58398C12.5 3.20327 11.3807 2.08398 10 2.08398C8.61929 2.08398 7.5 3.20327 7.5 4.58398V9.58398C7.5 10.9647 8.61929 12.084 10 12.084C11.3807 12.084 12.5 10.9647 12.5 9.58398V4.58398Z"
        stroke="#0A0A0A"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.16406 9.16602C4.16406 10.7131 4.77864 12.1968 5.87261 13.2908C6.96657 14.3848 8.4503 14.9993 9.9974 14.9993M9.9974 14.9993C11.5445 14.9993 13.0282 14.3848 14.1222 13.2908C15.2161 12.1968 15.8307 10.7131 15.8307 9.16602M9.9974 14.9993V17.916"
        stroke="#0A0A0A"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SendIcon = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M15.75 2.25L7.5 10.5M7.5 10.5L2.25 7.125L15.75 2.25L10.875 15.75L7.5 10.5Z"
        stroke="#0A0A0A"
        strokeWidth="1.725"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditDocumentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15px"
      height="15px"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.475 5.40783L18.592 7.52483M17.836 3.54283L12.109 9.26983C11.8122 9.56467 11.6102 9.94144 11.529 10.3518L11 12.9998L13.648 12.4698C14.058 12.3878 14.434 12.1868 14.73 11.8908L20.457 6.16383C20.6291 5.99173 20.7656 5.78742 20.8588 5.56256C20.9519 5.33771 20.9998 5.09671 20.9998 4.85333C20.9998 4.60994 20.9519 4.36895 20.8588 4.14409C20.7656 3.91923 20.6291 3.71492 20.457 3.54283C20.2849 3.37073 20.0806 3.23421 19.8557 3.14108C19.6309 3.04794 19.3899 3 19.1465 3C18.9031 3 18.6621 3.04794 18.4373 3.14108C18.2124 3.23421 18.0081 3.37073 17.836 3.54283Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 15V18C19 18.5304 18.7893 19.0391 18.4142 19.4142C18.0391 19.7893 17.5304 20 17 20H6C5.46957 20 4.96086 19.7893 4.58579 19.4142C4.21071 19.0391 4 18.5304 4 18V7C4 6.46957 4.21071 5.96086 5 5H9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};